import { Bell, BellRing, Smartphone } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useData } from './DataContext';
import {
  loadNotificationPreferences, requestNotificationPermission,
  saveNotificationPreferences, subscribeForPush,
} from './notificationService';

export function NotificationCentre() {
  const { team } = useData();
  const [prefs, setPrefs] = useState(loadNotificationPreferences);
  const [status, setStatus] = useState('');
  const categories = useMemo(() => ([
    ['match', 'Match reminders', '2 days and 4 hours before kick-off'],
    ['lineup', 'Published lineup', 'When the matchday squad / XI is published'],
    ['training', 'Training plan', 'When coaches publish training methods'],
    ['result', 'GDSFC results', 'First result and completed matchday'],
    ['news', 'GDSFC / club news', 'When relevant news is published'],
    ['club', 'Club announcements', 'Important Polonia messages'],
  ] as const), []);

  async function enablePush() {
    const permission = await requestNotificationPermission();
    if (!permission.ok) { setStatus(permission.message); return; }
    if (!team?.id) { setStatus('No active team.'); return; }
    const result = await subscribeForPush(team.id);
    setStatus(result.message);
  }

  return (
    <section className="metal-card notification-centre">
      <div className="settings-card-title">
        <BellRing size={24}/>
        <div><h2>Notifications</h2><p>iPhone / Android matchday and club alerts.</p></div>
      </div>
      <button className="gold-button notification-enable" type="button" onClick={() => void enablePush()}>
        <Smartphone size={17}/> Enable push on this device
      </button>
      {status && <p className="notification-status">{status}</p>}
      <div className="notification-pref-grid">
        {categories.map(([key,title,desc]) => (
          <label className="notification-pref" key={key}>
            <span><Bell size={16}/><strong>{title}</strong><small>{desc}</small></span>
            <input
              type="checkbox"
              checked={prefs[key]}
              onChange={(e) => {
                const next = {...prefs, [key]: e.target.checked};
                setPrefs(next);
                saveNotificationPreferences(next);
              }}
            />
          </label>
        ))}
      </div>
    </section>
  );
}
